module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "flexday-suite.57a38e46.svg";